export enum AccountsListConstType {
  AccountsList = 'ACCOUNTS_LIST'
}
export interface AccountsListInterface {
  type: AccountsListConstType
  payload: string[]
}

export type ActionAccountType = AccountsListInterface
